import { isBoolean } from 'lodash'

/**
 * 文字列の 'true' や 'false' などを真偽値に変換します
 * '0', 0 を falseに '1', 1 を true に変換します
 * @param string
 * @returns {boolean}
 */
window.parseBoolean = value => {
  if (isBoolean(value)) {
    return value
  }

  return parseInt(value, 10) === 1 || value === 'true'
}
